<script setup>
import {computed} from "vue";

const props = defineProps({
  color: {
    type: String,
    default: "default"
  },
  rounded: {
    type: Boolean,
    default: false
  }
});

const badgeClass = computed(() => {
  if (props.color === 'default') {
    return 'grey lighten-4 grey--text text--darken-2';
  }
  return `${props.color} lighten-5 ${props.color}--text text--darken-4`;
});
</script>

<template>
  <span
    :class="[
        'status-badge',
        badgeClass,
        rounded ? 'border-radius-xl' : 'border-radius-md'
      ]"
  >
    <slot></slot>
  </span>
</template>

<style scoped>
.status-badge {
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  width: auto;
  max-width: fit-content;
  min-height: 32px;
}
.border-radius-xl {
  border-radius: 16px;
}
.border-radius-md {
  border-radius: 6px;
}
</style>